<template>
  <QuotePreviewDrawer :visible.sync="visible" :title="title" />
</template>

<script>
import QuotePreviewDrawer from './QuotePreviewDrawer.vue'

const DEFAULT_TITLE = '报价方案预览'
const QUOTE_PREVIEW_ACTION = 'quote.preview'

export default {
  name: 'QuotePreviewDrawerHost',
  components: { QuotePreviewDrawer },
  data() {
    return {
      visible: false,
      title: DEFAULT_TITLE
    }
  },
  mounted() {
    document.addEventListener('cosmo-claw-ui-action', this.handleUiAction)
  },
  beforeDestroy() {
    document.removeEventListener('cosmo-claw-ui-action', this.handleUiAction)
  },
  methods: {
    handleUiAction(e) {
      const { name, params = {}} = e.detail || {}
      if (name !== QUOTE_PREVIEW_ACTION) return
      // 接住动作，避免卡片侧回退提示
      e.preventDefault()
      this.title = params.quoteNo ? `${DEFAULT_TITLE} · ${params.quoteNo}` : DEFAULT_TITLE
      this.visible = true
    }
  }
}
</script>
